import React from 'react';
import { Clock, Send, AlertCircle } from 'lucide-react';

export default function GestionEstadoHistorial({ 
  solicitud, 
  estados, 
  handleCambiarEstado, 
  setModalCorreo, 
  isRechazado 
}) {
  return (
    <>
      <div className="glass-card animate-fade-in" style={{ borderLeft: '4px solid var(--primary)' }}>
        <h4 style={{ margin: '0 0 1rem', display: 'flex', alignItems: 'center', gap: 8 }}>
          <Clock size={18} style={{ color: 'var(--primary)' }} /> Gestión de la Solicitud
        </h4>

        <div style={{ marginBottom: '1rem' }}>
          <label style={{ fontSize: '0.82rem', display: 'block', marginBottom: 4, fontWeight: 600 }}>
            Cambiar Estado:
          </label>
          <select className="form-control"
            value={solicitud.estado_id || ''}
            onChange={e => handleCambiarEstado(e.target.value)}
            style={{ fontSize: '0.85rem', padding: '6px' }}>
            {estados.map(est => (
              <option key={est.id} value={est.id}>{est.nombre}</option>
            ))}
          </select>
        </div>

        {/* Enviar correo al ciudadano */}
        <button className="btn btn-primary"
          style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 8 }}
          onClick={() => setModalCorreo(true)}>
          <Send size={16} /> Enviar Correo al Ciudadano
        </button>
      </div>

      {/* Aviso si está rechazada */}
      {isRechazado && (
        <div className="glass-card animate-fade-in" style={{ borderLeft: '4px solid #f59e0b', background: '#fdfbeb' }}>
          <h4 style={{ margin: '0 0 0.5rem', color: '#d97706', display: 'flex', alignItems: 'center', gap: 8 }}>
            <AlertCircle size={18} /> Solicitud Rechazada
          </h4>
          <p style={{ margin: 0, fontSize: '0.85rem', color: '#92400e' }}>
            Puedes cambiar el estado arriba para reactivar la solicitud si el ciudadano subsana los documentos requeridos.
          </p>
        </div>
      )}
    </>
  );
}
